import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import Utils from '@shared/utils/utils';
import Configs from '@shared/constants/configs';
import Roles from '@shared/constants/roles';
import { ApiService } from '@shared/apis';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '@env/environment';

@Component({
  selector: 'app-dp-img-select',
  templateUrl: './dp-img-select.component.html',
  styleUrls: ['./dp-img-select.component.scss']
})
export class DpImgSelectComponent implements OnInit {
  readonly configs = Configs;
  readonly roles = Roles;

  readonly backend = environment.api.backend;

  readonly imagePath = '/image/concealed-damage/server-file/';
  @Output()
  selectFile = new EventEmitter();
  @Output()
  showFile = new EventEmitter();
  @Output()
  outFile = new EventEmitter();
  @Output()
  fileDelete = new EventEmitter();
  @Output()
  addPhoto = new EventEmitter();
  files: any[] = [];
  file: any;
  isMobile = false;
  @ViewChild('imgFileInput') imgFileInput: ElementRef;

  constructor(private apiService: ApiService,
              private deviceService: DeviceDetectorService) {
  }

  _initInfo: any;

  @Input()
  set initInfo(value) {
    if (!value) {
      return
    }
    this._initInfo = value;
  };

  _photoInfo: any;

  @Input()
  set photoInfo(value) {
    this._photoInfo = value;
  };

  _deletable: boolean;

  @Input()
  set deletable(value) {
    if (!value) {
      return;
    }
    this._deletable = value;
  }

  /** When set, used as img src instead of default CD path (for reuse in ticket attachment etc.) */
  @Input() previewImageUrl: string;

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
  }

  isImageFile(file: any): boolean {
    const name = file?.filename || file?.name || '';
    if (!name) {
      return false;
    }
    return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(String(name).toLowerCase());
  }

  get hasImagePreview(): boolean {
    if (!this._photoInfo?.file) {
      return false;
    }
    return !!this.previewImageUrl || this.isImageFile(this._photoInfo.file);
  }

  fileSelected(event): any {
    const files = event.target.files;

    this.files = files;

    if (this.files.length > 0) {
      const overLimit = Array.from(this.files).some((f: any) => {
        return (f.size > this.configs.fileLimit.limit);
      });

      if (overLimit) {
        this.imgFileInput.nativeElement.value = '';
        const size = (this.configs.fileLimit.limit / (1024 * 1024)).toFixed(0);
        Utils.showError({ message: `The file is too large.  Please select size ${ size }MB or less.` });
        return false;
      }
    }

    this.file = files[0];
    this.outFile.emit(this.file);
  }

  delete($event) {
    $event.stopPropagation();
    $event.preventDefault();

    this.fileDelete.emit(this.file);
    this.file = null;
    this.files = [];
  }

  add(event) {
    this.addPhoto.emit(event)
  }

  clickFile() {
    // open modal
    this.showFile.emit(true)
  }

  selectImg() {
    const file = this.apiService.concealedDamage.fileUrl(this._photoInfo?.file, 'attachment');
    window.open(file);
  }

  deleteImg() {
    this.fileDelete.emit(true);
  }

}
